import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import TipPop from '~/components/common/TipPop';
import round from 'lodash/round'
import Spinner from '~/components/common/Spinner';
class CommonCheck extends React.Component{
  constructor (props) {
      super(props);
  }
  render () {
    const secondaryPages = this.props.secondaryPages;
    const targetPrice = this.props.targetPrice;
    const distance = this.props.distance;
    const loadRateAverage = (targetPrice && distance) ? (targetPrice / distance).toFixed(2) : null;//当前load平均值
    const sdRateAverage = this.props.sdRateAverage;//七天内的load平均值
    const fuelPrice = this.props.fuelPrice;//油价
    const loading = this.props.loading;
    //const linehaulRevenue = (distance && sdRateAverage) ? (distance * sdRateAverage).toFixed(2) : null;
    const linehaulRevenue = this.props.price;
    const fuelCost = (distance && fuelPrice) ? (distance * fuelPrice).toFixed(2) : null;
    const estRevenue = (linehaulRevenue - fuelCost >= 0) ? (linehaulRevenue - fuelCost).toFixed(2) : null;
    const difference = (sdRateAverage && loadRateAverage) ? loadRateAverage - sdRateAverage : null;
    const grossMargin =  (difference && difference > 0) ? (difference / sdRateAverage * 100).toFixed(2) : null;
    const question = 'What is Gross Margin?';
    const answer = 'Gross Margin is the percentage of the avg.rate higher than posted rate. Calculation formula is (posted rate-avg.rate)/avg.rate';
    return sdRateAverage ? (
      <div className={cs(css.checkContent)}>
       {/*  <div className={cs(css.averageProfit)}>${sdRateAverage} / mile(avg.rate)</div> */}
        {secondaryPages ? <div className={cs(css.loadAverageProfit)}>
          (Posted rate: ${targetPrice})
          {loadRateAverage ? <span>(${loadRateAverage}/mile)</span>: null}
        </div> : null}
        <div className={cs(css.form)}>
          <div className={cs(css.formHeader)}>
            <span className={cs(css.headerLeft)}>Revenue Info</span>
            <span className={cs(css.headerRight)}>included Fuel Surcharge</span>
            { 
              loading && 
              <div className={css.loading}>
                <Spinner scalable={true}/>
              </div>
            }
          </div>
          <div className={cs(css.formContent)}>
            <div>
              <div className={cs(css.title)}><span>Distance</span></div>
              <div className={cs(css.information)}>{round(distance, 0)}<span> mi</span></div>
            </div>
            <div className={css.formHr}></div>
            <div>
              <div className={cs(css.title)}><span>Avg. Rate</span></div>
              <div className={cs(css.information,css.specialInfo)}><span>$ </span>{round(sdRateAverage, 2)}<span>  / mile</span></div>
            </div>
            <div className={css.formHr}></div>
            <div>
              <div className={cs(css.title)}><span>Linehaul Revenue</span></div>
              {linehaulRevenue
                ? <div className={cs(css.information)}>
                  <span>$ </span>{round(linehaulRevenue, 2)}
                </div>
                : <div className={cs(css.information)}>--</div>
              }
            </div>
          </div>
          { false &&
            (<table className={cs(css.formContent)}>
            <tr>
              <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title)}><span>Distance</span></div>
                <div className={cs(css.information)}>{distance}<span> mi</span></div>
              </td>
              <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title)}><span>Avg. Rate</span></div>
                <div className={cs(css.information)}><span>$ </span>{sdRateAverage}<span>  / mile</span></div>
              </td>
              <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title)}><span>Linehaul Revenue</span></div>
                {linehaulRevenue
                  ? <div className={cs(css.information)}>
                    <span>$ </span>{linehaulRevenue}
                  </div>
                  : <div className={cs(css.information)}>--</div>
                }
              </td>
              {/* <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title)}><span>Est. Fuel Cost</span></div>
                {fuelCost
                  ? <div className={cs(css.information)}>
                    <span>$ </span>{fuelCost}
                  </div>
                  : <div className={cs(css.information)}>--</div>
                }
              </td>
              <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title)}><span>Est. Revenue</span></div>
                {estRevenue
                  ? <div className={cs(css.information)}>
                    <span>$ </span>{estRevenue}
                  </div>
                  : <div className={cs(css.information)}>--</div>
                }
              </td> */}
              {/* {secondaryPages ? <td className={cs(!secondaryPages && css.secondaryPages)}>
                <div className={cs(css.title, css.iconWrap)}>
                  <span>Gross Margin</span>
                  <img src="/assets/invalid-name.svg"/>
                  <span className={cs(css.iconBtnWrap)}><TipPop direction='bottomRight' QDocument={question} ADocument={answer}/></span>
                </div>
                {grossMargin
                  ? <div className={cs(css.information)}>
                    {grossMargin}<span> %</span>
                  </div>
                  : <div className={cs(css.information)}>--</div>
                }
              </td> : null} */}
            </tr>
          </table>)
          }
        </div>
        <div className={cs(css.formTail)}>
          The fuel surcharge may or may not be included in the revenue.
          The avg.rate is state-to-state average rate per mile.
        </div>
      </div>
    ) : (
      <div className={cs(css.checkContent)}>
        <p className={cs(css.contentTitle)}>Sorry, no average rate is provided.</p>
        <p className={cs(css.prompt)}>
          Avg.rates are only available if sufficient rate data is collected to build a avg.rate.
          <br/>
          We are working to expand the rate data to wider range of locations and equipment types.
        </p>
      </div>
    );
  }
}
export default connect((state, props) => ({
}))(CommonCheck);



// WEBPACK FOOTER //
// ./src/components/rate/common/commonCheck/index.js